















import { Vue, Component } from "vue-property-decorator"

const AppProps = Vue.extend({
	props: {}
})

@Component({})
export default class NotFound extends AppProps {
}
